import { actionTypes } from '@/core/constants'
import PenalidadesUrlBuilder from '@/core/utils/factory/penalidades/PenalidadesUrlBuilder'
import PenalidadesItensApiClient from '@/core/apiclient/penalidades/itens/PenalidadesItensApiClient'

function getApiClient(obj) {
	const urlBuilder = new PenalidadesUrlBuilder(obj.tipo)
	return new PenalidadesItensApiClient(urlBuilder)
}

export default {
	async [actionTypes.PENALIDADES.BUSCAR_ITENS_PENALIDADE](context, objt) {
		let apiClient = getApiClient(objt)
		let { data } = await apiClient.buscarItensPenalidade(objt)
		return data
	},
	async [actionTypes.PENALIDADES.ADICIONAR_ITENS_PENALIDADE](context, objt) {
		const { tipo, ...payload } = objt
		let apiClient = getApiClient({ tipo })
		let { data } = await apiClient.adicionarItensPenalidade(payload)
		return data
	},
}
